import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { CompanyAddBlueprintButton } from "./CompanyAddBlueprintButton";
import { CompanyAddCheckTypeButton } from "./CompanyAddCheckTypeButton";
import type { CompanyAssignCheckTypeButtonProps } from "./companyAssignCheckTypeButton.types";

export type { CompanyAssignCheckTypeButtonProps };

/** Query param `old=1` forces the legacy modal; otherwise the new table modal is used. */
function useCompanyAddCheckTypeModalEnabled(): boolean {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    return searchParams.get("old") !== "1";
  }, [searchParams]);
}

/**
 * Assign Check Type entry point. Renders the new check-types table modal by
 * default, or the legacy blueprint-list modal when `?old=1` is present.
 */
export const CompanyAssignCheckTypeButton = (
  props: CompanyAssignCheckTypeButtonProps
) => {
  const useNewModal = useCompanyAddCheckTypeModalEnabled();

  if (useNewModal) {
    return <CompanyAddCheckTypeButton key="assign-check-type-v2" {...props} />;
  }

  return <CompanyAddBlueprintButton key="assign-check-type-legacy" {...props} />;
};
